module.exports = __webpack_public_path__ + "static/sajallogo-29aa89a0d1e0536dcd9764ef3ab4655f.png";